import React, { forwardRef } from 'react';
import { ALL_SLASH_ITEMS } from './EditorConfig';

const SlashMenu = forwardRef(({ editor, position, filter, selectedIndex, onHoverUrl, promptImage }, ref) => {
    if (!editor || !position) return null;

    const filteredSlash = ALL_SLASH_ITEMS.filter(item =>
        item.label.toLowerCase().includes(filter) ||
        item.desc.toLowerCase().includes(filter)
    );

    if (filteredSlash.length === 0) return null;

    // Group filtered items by category
    const groupedSlash = filteredSlash.reduce((acc, item) => {
        if (!acc[item.category]) acc[item.category] = [];
        acc[item.category].push(item);
        return acc;
    }, {});

    const executeSlash = (index) => {
        if (!editor) return;
        const item = filteredSlash[index];
        if (!item) return;

        // Delete the slash command text
        const { state } = editor;
        const { $from } = state.selection;
        const textBefore = $from.parent.textContent.slice(0, $from.parentOffset);
        const slashMatch = textBefore.match(/\/([a-zA-Z]*)$/);
        if (slashMatch) {
            const deleteFrom = $from.pos - slashMatch[0].length;
            editor.chain().focus().deleteRange({ from: deleteFrom, to: $from.pos }).run();
        }

        item.command(editor, { promptImage });
    };

    return (
        <div
            ref={ref}
            className="tiptap-slash"
            style={{ top: position.top, left: position.left }}
        >
            {Object.entries(groupedSlash).map(([category, items]) => (
                <div key={category}>
                    <div className="tiptap-slash__category">{category}</div>
                    {items.map((item) => {
                        const Icon = item.icon;
                        const idx = filteredSlash.indexOf(item);
                        return (
                            <button
                                key={item.label}
                                className={`tiptap-slash__item ${idx === selectedIndex ? 'tiptap-slash__item--active' : ''}`}
                                onClick={() => executeSlash(idx)}
                                onMouseEnter={() => onHoverUrl?.(idx)}
                            >
                                <Icon size={16} />
                                <div className="tiptap-slash__item-text">
                                    <span className="tiptap-slash__item-label">{item.label}</span>
                                    <span className="tiptap-slash__item-desc">{item.desc}</span>
                                </div>
                            </button>
                        );
                    })}
                </div>
            ))}
        </div>
    );
});

export default SlashMenu;
